import React, { useEffect, useState } from "react";
import { api, BACKEND_URL } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { FileText, ExternalLink, CheckCircle2 } from "lucide-react";

export default function PlatformDocs() {
  const [docs, setDocs] = useState([]);
  useEffect(() => { api.get("/admin/platform-docs").then((r) => setDocs(r.data || [])).catch(() => {}); }, []);
  return (
    <div className="space-y-5 max-w-4xl" data-testid="platform-docs-page">
      <div>
        <p className="text-xs font-medium tracking-wider uppercase text-muted-foreground">Impostazioni</p>
        <h1 className="font-head text-3xl font-bold tracking-tight mt-1">Specifiche &amp; revisioni</h1>
        <p className="text-sm text-muted-foreground mt-1">I documenti di specifica della piattaforma, con le decisioni confermate. Visibili solo agli admin.</p>
      </div>
      {docs.map((d) => (
        <Card key={d.id} className={`p-5 space-y-3 ${d.status === "in_vigore" ? "glow-border" : "opacity-80"}`} data-testid={`platform-doc-${d.id}`}>
          <div className="flex flex-wrap items-start gap-3">
            <FileText className="w-5 h-5 text-primary shrink-0 mt-0.5" />
            <div className="flex-1 min-w-0"><h2 className="font-head font-semibold">{d.title} · {d.revision}</h2><p className="text-xs text-muted-foreground">{new Date(d.date).toLocaleDateString("it-IT")} · {d.note}</p></div>
            <Badge className={d.status === "in_vigore" ? "bg-emerald-600 hover:bg-emerald-600" : "bg-secondary text-foreground hover:bg-secondary"} data-testid={`platform-doc-status-${d.id}`}>{d.status === "in_vigore" ? "In vigore" : "Superata"}</Badge>
            {d.available && <Button asChild size="sm" variant="outline" className="gap-1"><a href={`${BACKEND_URL}/api/admin/platform-docs/${d.id}/file`} target="_blank" rel="noopener noreferrer" data-testid={`platform-doc-open-${d.id}`}><ExternalLink className="w-4 h-4" /> Apri PDF</a></Button>}
          </div>
          {d.decisions.length > 0 && <div className="rounded-lg bg-secondary/40 p-3 space-y-1.5" data-testid={`platform-doc-decisions-${d.id}`}>
            <p className="text-xs font-semibold uppercase tracking-wider text-muted-foreground">Decisioni confermate</p>
            {d.decisions.map((x) => <p key={x} className="text-sm flex gap-2"><CheckCircle2 className="w-4 h-4 text-emerald-500 shrink-0 mt-0.5" />{x}</p>)}
          </div>}
        </Card>
      ))}
    </div>
  );
}
